
ADILF.define('adilf/util/markup-to-config',['require','exports','module','streamhub-sdk/jquery'],function (require, exports, module) {/* Utility: HTML-to-config parser */
"use strict";
var jquery = require('streamhub-sdk/jquery');

var _str2bool = function(val) {
    switch(val) {
        case "true":
            val = true;
            break;
        case "false":
            val = false;
            break;
    }
    return val;
};

module.exports = {
    parse: function(el) {
        var cfg = {};
        if(typeof el === "string") {
            el = document.getElementById(el);
        } else if (el instanceof jquery) {
            el = el.get(0);
        }
        if(!el) { return cfg; }
        for (var i = 0; i < el.attributes.length; i++) {
            var attrib = el.attributes[i];
            if (attrib.name.match(/data\-lf\-/)) {
                var key = attrib.name.replace(/data\-lf\-/,"");
                // convert livefyre markup to key
                switch(key) {
                    case "article-id":
                        key = "articleId";
                        break;
                    case "site-id":
                        key = "siteId";
                        break;
                    case "network-id":
                        key = "networkId";
                        break;
                }
                cfg[key] = _str2bool(attrib.value);
            }
        }
        return cfg;
    }
};
});
